import { FC } from 'react'

import { Text } from '../../UI'

const TableLabel:FC<{ inline?: boolean }> = ({ children, inline = false }) => <Text component="label" color="primary" size="14" inline>{children}</Text>

export { TableLabel }